<template>
  <ipo3-page>
    <template slot="title">編輯</template>
    <template slot="tools">
      <el-button type="primary" @click="goBack" icon="el-icon-back">返回列表</el-button>
    </template>
    <template slot="page">
      <div id="home-edit">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="類型" prop="type">
            <el-select v-model="ruleForm.type" placeholder="請選擇分類">
              <el-option v-for="(item,index) in types" :key="item" :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="標題" prop="title">
            <el-input v-model="ruleForm.title" autocomplete="off">
              <template slot="prepend">繁</template>
            </el-input>
            
            <el-input v-model="ruleForm.title_cn" autocomplete="off">
              <template slot="prepend">簡</template>
            </el-input>

            <el-input v-model="ruleForm.title_en" autocomplete="off">
              <template slot="prepend">英</template>
            </el-input>
          </el-form-item>

          <el-form-item label="縮略圖" prop="thumb">
            <ipo3-upload @success="onSuccess" ref="upload"></ipo3-upload>
          </el-form-item>
          <el-form-item label="跳轉網頁" prop="other">
            <el-input v-model="ruleForm.other">
            </el-input>
          </el-form-item>
          
          <el-form-item label="是否顯示" prop="status">
            <el-switch v-model="ruleForm.status"></el-switch>
          </el-form-item>
        
          

          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      
    </template>
  </ipo3-page>
</template>
<script>
const types = ["首頁廣告圖"]; 
// Load a plugin.
export default {
  name: "home-edit",
  data() {
    return {
      drawer: false,
      direction: "rtl",
      tableData: [],
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" }
      ],
      types: types,
      news: null,
      edit: false,
      ruleForm: {
        type: 0,
        other: '',
        title: "",
        title_cn: "",
        title_en: "",
        status: true,
        id: 0
      }
    };
  },

  created() {
    if (this.$route.params.id !== undefined) {
      this.edit = true;
      this.ruleForm.id = this.$route.params.id;
      this.getData(this.$route.params.id);
    }

  },

  methods: {
    getData(id) {
      var self = this;
      this.$http.get("/admin/banner/detail", { id: id }).then(res => {
        self.ruleForm = res.data;
        self.$refs.upload.setImage({
          url: self.ruleForm.thumb,
          name: "news.jpg"
        });
        self.ruleForm.status = self.ruleForm.status==1?true:false;
        self.ruleForm.type = Number(self.ruleForm.type);
        
      });
    },
    onSuccess(image) {
      this.ruleForm.thumb = image.path;
    },
    
    onHandle(value) {
      this.news = value;
      this.drawer = false;
    },
    onSubmit() {
      let params = Object.assign({},this.ruleForm);
      params.status = params.status ? 1 : 0;
      this.$http.post("/admin/banner/edit", params).then(res => {
        console.log("res:", res);
        if(res.code==200)
        {
          this.$message.success("編輯成功");
        }else
        {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less">
#home-edit {
  width: 800px;
  text-align: left;
}
</style>